var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_10584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.000976562C2.692 0.000976562 0 2.73398 0 6.09398C0 7.42298 0.414 8.68698 1.197 9.74698L5.63 15.811C5.641 15.826 5.658 15.832 5.67 15.844C5.892 16.085 6.212 16.025 6.369 15.811C7.646 14.081 9.986 10.85 10.886 9.63098V9.62998L10.892 9.62198C11.617 8.58798 12 7.36798 12 6.09398C12 2.73398 9.308 0.000976562 6 0.000976562ZM6 9.38098C4.219 9.38098 2.763 7.90298 2.763 6.09398C2.763 4.28498 4.219 2.80698 6 2.80698C7.781 2.80698 9.237 4.28498 9.237 6.09398C9.237 7.90298 7.781 9.38098 6 9.38098Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_10584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.e3f227f80fa128a23d35b501e6ba223b.svg";
export { ForwardRef as ReactComponent };